import { communitAPI } from ".";

export async function getCoinGroup(params: { id: string }) {
  return (
    await communitAPI.request<
      Moim.ISingleItemResponse<Moim.Community.Coin.ICoinGroup>
    >({
      method: "GET",
      url: `/coin_groups/${params.id}`,
    })
  ).data;
}

export async function getCoinGroupCoinList(params: { id: string }) {
  return (
    await communitAPI.request<
      Moim.IPaginatedListResponse<Moim.Community.Coin.ICoin>
    >({
      method: "GET",
      url: `/coin_groups/${params.id}/coins`,
    })
  ).data;
}

export async function getCoinGroupBalance(params: { id: string }) {
  return (
    await communitAPI.request<
      Promise<Moim.ISingleItemResponse<Moim.Community.Coin.ICoinGroupBalance>>
    >({
      method: "GET",
      url: `/coin_groups/${params.id}/coins/balance`,
    })
  ).data;
}
